<template>
    <div class="page home-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <lecture v-if="lectureData" :lecture="lectureData.lecture" :videos="lectureData.videos" :exams="lectureData.exams" :attachments="lectureData.attachments" :purchases="lectureData.purchases" :stats="lectureData.stats" :exams_select_items="lectureData.exams_select_items" @loadMore="loadMore" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Lecture from './Lecture'

export default {
    name: "",
    components: {
        Lecture
    },
    data(){
        return {
            loading: false,
            lectureData: null,
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        
    },
    methods: {
        ...GlobalMethods,
        loadData(page=null){
            if (!this.loading){
                this.loading = true;

                window.axios.get(`/lectures/${this.id}${page ? '?page=' + page : ''}`).then(response=>{
                    this.lectureData = response.data;
                    this.loading = false;
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        this.$router.push('/not-found')
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
        loadMore(page){
            this.loadData(page);
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>

</style>
